<template>
  <div class="built-heading">
      <div v-if="done">
          <div class="heading-inner">
              <span class="title">Done!</span>
          </div>
      </div>

      <div v-else>
          <button class="tc-previous tc-nav-btn btn" @click="$store.dispatch('previous')" :class="{hidden: hidePrevious}"></button>

          <div class="heading-inner">
              <button class="reset btn" v-if="showResetColors" @click="$store.commit('setColors', {})">Reset Colors</button>

              <button class="reset btn" v-if="showResetLayout" @click="$store.commit('setLayoutStyles', {})">Reset Layout</button>

              <span class="title" v-if="currentPattern">{{currentPattern.name}}</span>
              <span class="title" v-else>Select Pattern</span>
          </div>

          <button class="tc-next tc-nav-btn btn" @click="$store.dispatch('next')" :class="{hidden: hideNext}" :disabled="!next"></button>
      </div>
  </div>
</template>

<script>

export default {
  name: 'BuiltHeading',
  data: function(){
      return {

      }
  },
  props: ['next'],
  computed: {
      showResetColors(){
          return this.$store.state.step.index == 1;
      },
      showResetLayout(){
          return this.$store.state.step.index == 2;
      },
      hidePrevious(){
          return this.done || this.currentStep.index == 0;
      },
      hideNext(){
          return this.done || this.currentStep.index == this.steps.length - 1;
      },
      currentStep(){
          return this.$store.state.step;
      },
      currentPattern(){
          return this.$store.state.pattern;
      },
      done(){
          return this.$store.state.done;
      },
      steps(){
          return this.$store.state.steps;
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .heading-inner{
        text-align: center;
        position: relative;
    }

    .built-heading{
        text-align: left;
        padding: 0 75px;
        background-color: #ececec;
        /*margin-top: 15px;*/
        position: relative;
    }

    .title{
        padding: 13px 15px;
        display: block;
        font-size: 18px;
    }

    .tc-nav-btn{
        position: absolute;
        top: 8px;
        background-repeat: no-repeat;
        height: 35px;
        width: 45px;
        background-color: cornflowerblue;
        background-size: 90%;
        transition: all 0.2s ease-in-out;

        &:disabled{
            opacity: 0.3;
        }
    }

    .tc-previous{
        left: 15px;
        background-image: url('../assets/left.png');
        background-position: center;
    }

    .tc-next{
        right: 15px;
        background-image: url('../assets/right.png');
        background-position: center;
    }

    .reset{
        position: absolute;
        top: 9px;
        right: 0;
        background-color: cornflowerblue;

        &, &:hover, &:active, &:focus{
            color: #fff;
        }
    }

</style>
